module.exports = __webpack_public_path__ + "img/danye11.2ff6738e.jpg";